import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { PaymentComponent } from './payment/payment.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeRedirectComponent } from './home-redirect/home-redirect.component';
import { PaymentMultiComponent } from './payment-multi/payment-multi.component';


const routes: Routes = [
  {path: '', redirectTo: '/redirect', pathMatch: 'full'},
  {path: 'info', component: HomeComponent},
  {path: 'payment/:deviceId/:userId/:token/:mosqueId/:graveId/:myPlaceId/:placeType/:details/:locale', component: PaymentComponent},
  {path: 'payment/:deviceId/:userId/:token/:transactionId/:locale', component: PaymentMultiComponent},
  {path: 'payment/:deviceId/:userId/:token/:transactionId/:locale/:platform', component: PaymentMultiComponent},
  {path: 'redirect', component: HomeRedirectComponent},
  {path: '**', component: PageNotFoundComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
